/**
 * scanTaskBus — bus léger côté client pour orchestrer les analyses de
 * factures en tâche de fond. La page Factures publie un `taskId` dès que
 * le serveur a créé la tâche ; un composant global dans Layout écoute et
 * poll l'état du serveur pour afficher les notifications correspondantes.
 *
 * Le bus vit *hors* du cycle de vie de <Invoices/> : l'analyse survit à
 * un changement de page et à un F5 (le taskId est conservé en
 * localStorage tant que la tâche n'est ni completed / review_required
 * (ouverte) ni failed acquittée).
 */
const STORAGE_KEY = "rentascan:active-scan-tasks";
const EVENT_NAME = "rentascan:scan-tasks-changed";

function readIds() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter(Boolean) : [];
  } catch {
    return [];
  }
}

function writeIds(ids) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch { /* quota / disabled — silencieux */ }
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { ids } }));
  } catch { /* jsdom */ }
}

export const scanTaskBus = {
  getIds: readIds,
  add(id) {
    if (!id) return;
    const cur = readIds();
    if (cur.includes(id)) return;
    writeIds([...cur, id]);
  },
  remove(id) {
    if (!id) return;
    const cur = readIds();
    const next = cur.filter((x) => x !== id);
    if (next.length !== cur.length) writeIds(next);
  },
  clear() {
    writeIds([]);
  },
  subscribe(cb) {
    const handler = (e) => cb(e.detail?.ids ?? readIds());
    window.addEventListener(EVENT_NAME, handler);
    // Cross-tab support
    const storageHandler = (e) => {
      if (e.key === STORAGE_KEY) cb(readIds());
    };
    window.addEventListener("storage", storageHandler);
    return () => {
      window.removeEventListener(EVENT_NAME, handler);
      window.removeEventListener("storage", storageHandler);
    };
  },
};
